import { Logo } from "app/features/navigation/atoms/Logo";
import { View } from "react-native";
import { Redirect } from "expo-router";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
export default function AuthHomePage() {
  const { checkPermission } = usePermissionCheck();

  if (checkPermission(PermissionsEnums.VIEW_CALENDAR_EVENT))
    return <Redirect href="/calendar" />;

  return (
    <View className="flex-1 items-center justify-center">
      <Logo size="xl" />
    </View>
  );
}
